export default {
    methods: {
        getValidationState({ errors, passed }) {
            return errors[0] ? false : passed ? true : null;
        },
    },
};
